import { render, staticRenderFns } from "./proveedor.info.vue?vue&type=template&id=2d1afa17&scoped=true&"
import script from "./proveedor.info.vue?vue&type=script&lang=js&"
export * from "./proveedor.info.vue?vue&type=script&lang=js&"
import style0 from "./proveedor.info.vue?vue&type=style&index=0&id=2d1afa17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1afa17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VImg})
